import { FelloraMark } from './FelloraMark';

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={compact ? 'brand brand--compact' : 'brand'} aria-label="Fellora">
      <FelloraMark className="brand__mark" />
      <span className="brand__wordmark">Fellora</span>
    </div>
  );
}
